import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(
  (theme) => ({
    link: {
      color: "inherit"
    },
  })
);

export default function GeolocationErrorDialog() {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Dialog
      open
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">
        {t("navigation:noGeolocationDialog:title")}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {t("navigation:noGeolocationDialog:description")}
          <br/><br/>
          <a href="https://help.getassist.app/nb/articles/11003834-gi-assist-tilgang-til-posisjonen-din-pa-iphone" className={classes.link} target="_blank">{t("navigation:noGeolocationDialog:link")}</a>
        </Typography>
        
      </DialogContent>
       <DialogActions>
        <Button variant="contained" color={"primary"} onClick={() => navigate("../", { relative: "path" })}>
          {t("common:back")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

